import { render, staticRenderFns } from "./CadastroAvisoPrevio.vue?vue&type=template&id=338f6df8&scoped=true"
import script from "./CadastroAvisoPrevio.vue?vue&type=script&lang=js"
export * from "./CadastroAvisoPrevio.vue?vue&type=script&lang=js"
import style0 from "./CadastroAvisoPrevio.vue?vue&type=style&index=0&id=338f6df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f6df8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
